import './../stylus/index.styl';
import $ from "jquery";
import { NODE_ENV, apiUrl, csrfMethod, loadQuestionUrl, loadQuestionMethod, checkDateUrl, checkDateUrlMethod, checkClickUrl, checkClickUrlMethod, checkStoreUrl, checkStoreUrlMethod} from './../../config.js';

$(function () {

  // 確認來源
  var validSources = ['vision', 'ctbc', 'esg', 'fb', 'line', 'ig', 'edm'];
  var sourceParam = checkSource();

  var source = validSources.includes(sourceParam) ? sourceParam : 'actnow';
  // console.log(source);

  $('[data-source="source"]').attr('href', function() {
    var href = $(this).attr('href');
    return addQueryParam(href, 'source', source);
  });

  function checkSource() {
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('source') || '';
  }

  function addQueryParam(url, paramName, paramValue) {
    var separator = url.indexOf('?') !== -1 ? '&' : '?';
    return url + separator + paramName + '=' + encodeURIComponent(paramValue);
  }

  // GoTop
  var ScrollTop = function () {

    var btnTop = document.querySelector('#gotop');
  
    var btnDistance = function (){
        if(window.pageYOffset >= 500){
            btnTop.classList.add('show');
        }else{
            btnTop.classList.remove('show');
        }
    }
  
    var TopscrollTo = function () {
    
        if(window.pageYOffset !=0){
            window.scrollTo({
                top: top,
                left: 0,
                behavior: 'smooth'
            });
        }
    }
  
    window.addEventListener('scroll', btnDistance);
    btnTop.addEventListener('click', TopscrollTo);
  }
  ScrollTop();


  // resize event
  $(window).on('resize', function () {
    $('.menu-toggle').removeClass('active');
    $('.mobileMenu').removeClass('open');
    $('.mobileMenu-item').removeClass('active');
    $('.mobileMenu-item').removeClass('animate');
    $('.overlay').removeClass('show');
  });


  // mobile 漢堡控制
  $('.menu-toggle, .overlay').on('click', function () {
    $('.menu-toggle').toggleClass('active');
    $('.mobileMenu').toggleClass('open');
    $('.mobileMenu-item').removeClass('active');
    $('.overlay').toggleClass('show');

    if($('.mobileMenu').hasClass('open')) {
      $('.mobileMenu-item').addClass('animate');
    } else {
      $('.mobileMenu-item').removeClass('animate');
    }
  });


  // mobile submenu 下滑控制
  $('.mobileMenu-item').on('click', function () {
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      // return false;
    }
    $('.mobileMenu-item').removeClass('active');
    $('.mobileMenu-item').removeClass('animate');
    $(this).addClass('active');
    // turn
  });


  // 頁籤資料切換
  $(".tab-switch").on('click', function (e) {
		var target = e.target.attributes["data-href"].value;
		// content
		$(".tab-content").addClass("none");
		$(".tab-content[data-rel=" + target + "]").removeClass('none');
		// active
		$(".tab-switch").removeClass("active");
		$(this).addClass("active");
	});


  // 頁籤資料切換
  $(".QA-switch").on('click', function (e) {
		var targetContent = e.target.attributes["data-href"].value;
    // console.log(targetContent)
		// content
		$(".QA-content").addClass("none");
		$(".QA-content[data-rel=" + targetContent + "]").removeClass('none');
    $(".full").addClass("none");
		$(".full[data-rel=" + targetContent + "]").removeClass('none');
		// active
		$(".QA-switch").removeClass("active");
		$(this).addClass("active");
	});

  $(".award-switch").on('click', function (e) {
		var targetContent = e.target.attributes["data-href"].value;
    // console.log(targetContent)
		// content
		$(".award-content").addClass("none");
		$(".award-content[data-rel=" + targetContent + "]").removeClass('none');
		// active
		$(".award-switch").removeClass("active");
		$(this).addClass("active");
	});


  // 定義題庫
  let questionBank;


  // 載入題庫
  loadQuestion();
  function loadQuestion() {
    $.ajax({
      method: loadQuestionMethod,
      url: loadQuestionUrl,
      dataType:'json',
    })
    .done(function (res) {
      questionBank = res;
    })
    .fail(function (error) {
      console.log("系統忙碌中，請重新操作！");
    });
  }

  // 建立題目空陣列
  const questionList = [];

  // 選擇題數
  const NUM_QUESTIONS = 10;

  // 下線
  const currentDate = new Date();
  // const targetDate = new Date("2023-09-28T09:30:00"); // 測試用
  const targetDate = new Date("2023-10-02T22:00:00");
  // console.log(currentDate, targetDate);

  // 檢查是否切換下線
  if (currentDate >= targetDate) {
      // 下線（不送資料）
      // console.log('不送資料');

      // 按下 play 按鈕產生題目 & 不串 api
      $('.play').on('click', function() {

        // 避免重複點選按鈕
        if ($(this).attr("disabled")) return;
        
        // 凍結按鈕
        $(this).attr("disabled", true);
        // console.log('凍結按鈕');

        $('.play').hide();
        $('.describe').hide();
        $('.facebook-test').hide();
        $('.form-progress').removeClass('none');

        // 隨機選擇 10 組題型
        const selectedTypes = shuffle(questionBank).slice(0, 10);

        // 選擇每組題型中的 1 題
        const questions = selectedTypes.flatMap((type) => {
          return shuffle(type.questions).slice(0, 1);
        });

        // 儲存題目
        const selectedQuestions = questions.map((question) => {
          return {
            question: question.question,
            // choices: shuffle(question.choices),
            choices: question.choices,
            answer: question.answer,
            text: question.text,
            link: question.link
          };
        });

        // 將題目存入陣列中
        for (let i = 0; i < NUM_QUESTIONS && i < selectedQuestions.length; i++) {
          questionList.push(selectedQuestions[i]);
        }

        // console.log(questionList);
        
        // 產生題目
        restartQuestions();

        // 解除按鈕凍結
        $(".go.play").attr("disabled", false);
        // console.log('解除按鈕凍結');

      });

    } else {
      // 上線（送資料）
      console.log('送資料');

      // 按下 play 按鈕產生題目 & 串 api
      $('.play').on('click', function() {

        var sendData = {
          source: checkSource(),
          deviceType: deviceType
        }
        // console.log(sendData);
        // 避免重複點選按鈕
        if ($(this).attr("disabled")) return;
        
        // 凍結按鈕
        $(this).attr("disabled", true);
        // console.log('凍結按鈕');

        // 計次 & 傳送來源
        grecaptcha.execute('6LcA97YUAAAAAN9SVpbme1g1312tmkQkHHp3rN3Y', {action: 'submit'}).then(function (token) {
          // 傳遞動態 token
          sendData.token = token;
          // console.log(checkDateUrl);
          // 送出資料
          $.ajax({
            method: checkDateUrlMethod,
            url: checkDateUrl,
            dataType:'json',
            data: JSON.stringify(sendData),
          })
          .done(function (res) {
            if (res.status === true) {
              console.log("check_date 串接成功");
              $.ajax({
                method: checkClickUrlMethod,
                url: checkClickUrl,
                dataType:'json',
                data: JSON.stringify(sendData),
              })
              .done(function (res) {
                if (res.status === true) {
                  console.log("click 串接成功");
                  // console.log(sendData);
                  // 產出題目
                  // 影藏 play
                  $('.play').hide();
                  $('.describe').hide();
                  $('.facebook-test').hide();
                  $('.form-progress').removeClass('none');

                  // 隨機選擇 10 組題型
                  const selectedTypes = shuffle(questionBank).slice(0, 10);

                  // 選擇每組題型中的 1 題
                  const questions = selectedTypes.flatMap((type) => {
                    return shuffle(type.questions).slice(0, 1);
                  });

                  // 儲存題目
                  const selectedQuestions = questions.map((question) => {
                    return {
                      question: question.question,
                      // choices: shuffle(question.choices),
                      choices: question.choices,
                      answer: question.answer,
                      text: question.text,
                      link: question.link
                    };
                  });

                  // 將題目存入陣列中
                  for (let i = 0; i < NUM_QUESTIONS && i < selectedQuestions.length; i++) {
                    questionList.push(selectedQuestions[i]);
                  }

                  // console.log(questionList);
                  
                  // 產生題目
                  restartQuestions();

                  // 解除按鈕凍結
                  $(".go.play").attr("disabled", false);
                  // console.log('解除按鈕凍結');

                } else {
                  console.log("click 串接失敗");
                  $(".go.play").attr("disabled", false);
                  Swal.fire({
                    icon: 'error',
                    text: res.message,
                    width: 300,
                    allowOutsideClick: false, // 阻止黑頻關閉燈箱
                    confirmButtonText: '關閉',
                  }).then(() => {
                    location.href = location.href
                  });
                }
              })
            } else {
              console.log("check_date 串接失敗");
              $(".go.play").attr("disabled", false);
              Swal.fire({
                icon: 'error',
                text: res.message,
                width: 300,
                allowOutsideClick: false, // 阻止黑頻關閉燈箱
                confirmButtonText: '關閉',
              });
            }
          })
          .fail(function (error) {
            console.log("系統忙碌中，請重新操作！");
          });
        });

      });

    }


  // 產生題目 HTML
  function renderQuestions(questions) {

    // 取得題目容器
    const questionContainer = $('.question-container');

    // 清空舊的題目
    questionContainer.empty();

    // 逐一產生新的題目
    questions.forEach((question, index) => {
      // 建立題目元素
      const questionElement = $(`
        <div class="block" data-index="${index}">
          <div class="topic"><div class="num"></div><div class="text">${question.question}</div></div>
          <div class="supply">${question.link}</div>
          <div class="answer-group">
            ${question.choices.map(choice => `
              <span class="button">${choice}</span>
            `).join('')}
          </div>
        </div>
      `);

      // 繫結選擇答案事件
      questionElement.on('click', '.button', function() {
        // 取得使用者選擇的答案
        const selectedAnswer = $(this).text();
        // const now = Number($(this).closest('.block').attr('data-index')) + 1;
        const now = Number($(this).closest('.block').attr('data-index')) + 1;
        const questionAnswer = (selectedAnswer === question.answer) ? '○' : 'X' ;
        const questionBu = (currentQuestion === questionList.length - 1) ? 'finish' : 'next' ;
        // const questionText = (currentQuestion === questionList.length - 1) ? '完成測驗 & 留 mail' : '下一題' ;
        const questionText = (currentQuestion === questionList.length - 1) ? (currentDate >= targetDate ? '完成測驗' : '完成測驗 & 留 mail') : '下一題';
        let isCorrect = 0;
        // let playState = 'paly';

        // 將使用者選擇的答案與正確答案比較，答對 +10
        if (selectedAnswer === question.answer) {
          score += 10;
          isCorrect = 1;
        } else {
          isCorrect = 0;
        }

        // console.log('當前狀態:' + playState);

        // 加入本題的答題結果到 allQuestionData 陣列中
        if (playState === 'paly') {
          allQuestionData.push({
            question: question.question,
            answer: question.answer,
            selectedAnswer: selectedAnswer,
            isCorrect: isCorrect
          });
          allQuestion.push(question.question),
          allSelectAns.push(selectedAnswer),
          allIsCorrect.push(isCorrect),
          sendAllQuestionData.allQuestion = allQuestion,
          sendAllQuestionData.selectedAnswer = allSelectAns,
          sendAllQuestionData.allIsCorrect = allIsCorrect,
          sendAllQuestionData.questionData = allQuestionData
        };

        // 燈箱相關
        // 設燈箱背景色
        $('body').addClass('ans');
        // 開燈箱
        Swal.fire({
          html: `
            <div class="youAnswer">你的回答：${selectedAnswer}（ ${questionAnswer} ）</div>
            <div class="focus">正確答案：${question.answer}</div>
            <div class='text'>${question.text}</div>
            <div class='link'>${question.link}</div>
            <div class='${questionBu}'>${questionText} <div class="arrow"></div></div>
          `,
          allowOutsideClick: false, // 阻止黑頻關閉燈箱
          showConfirmButton: false,
          hideClass: {
            popup: 'animated fadeOutUp faster',
          }
        })
        // 每次作答紀錄
        // console.log('選擇答案:', selectedAnswer, ',正確答案:', question.answer, ',答案圖示:', questionAnswer);
      });

      // 如果不是第一題，則隱藏
      if (index !== 0) {
        questionElement.hide();
      } else {
        // 如果是第一題，則顯示
        questionElement.show();
      }

      // 將題目元素加入題目容器
      questionContainer.append(questionElement);

    });
  }


  // 填寫 mail 的表單 HTML
  const emailFormHtml = `
    <div class="form-group">
      <div class="form-text">
        請輸入正確的 E-mail 格式
      </div>
      <input type="text" id="email" placeholder="E-mail（必填）">
      <label>
        <input type="checkbox" name="readRules1" id="agree" checked>
        <div class="check">我已詳閱 <a href="notice.html" data-source="source" target="_blank">活動辦法</a> 並且同意所有事項</div>
      </label>
      <label>
        <input type="checkbox" name="readRules2" id="order" checked>
        <span>是否願意收到願景工程相關永續訊息</span>
      </label>
      <div class="invalid-feedback"></div>
    </div>
    <p></p>
    <div class='formBu'>傳送 E-mail & 看測驗結果</div>
  `


  // 下一題
  $('body').on('click', '.next', function () {
    Swal.close();
    showNextQuestion();
  });


  // 完成測驗的按鈕事件
  $('body').on('click', '.finish', function () {
    playState = 'end';
    // console.log('當前狀態:' + playState);

    // 計算分數
    renderScore(score); // 測試時，看分數使用

    // 加入答題後的所有結果 & 分數，到 sendAllQuestionData 陣列中
    if (playState !== 'paly') {
      sendAllQuestionData.score = score;
    }

    // console.log(sendAllQuestionData);

    // 在事件處理內獲取當前時間
    const currentDate = new Date();

    if (currentDate <= targetDate) {
      // 上線
      // 以 SweetAlert 彈出填寫 mail 的表單
      Swal.fire({
        html: emailFormHtml,
        allowOutsideClick: false, // 阻止黑頻關閉燈箱
        showCancelButton: false,
        showConfirmButton: false,
        focusConfirm: false
      });
    } else {
      // 將 sendAllQuestionData 儲存到本地儲存區
      sessionStorage.setItem('sendAllQuestionData', JSON.stringify(sendAllQuestionData));
  
      // 導轉頁面
      guideResult(score);
    }

  });


  // mail驗證事件
  $('body').on('click', '.formBu', function () {

    // 取得填寫的 Email
    var email = $('#email').val().trim();

    if ($("#email").val() === "") {
      $('.invalid-feedback').html('請填寫「E-mail」');
      return false;
    } 
    if (!/^[0-9a-zA-Z_.-]+@[0-9a-zA-Z_.-]+\.[a-zA-Z_.-]+$/.test(email)) {
      $('.invalid-feedback').html('「E-mail」格式錯誤！');
      return false;
    }
    if (!/^[0-9a-zA-Z_.-]+@[0-9a-zA-Z_.-]+\.[a-zA-Z_.-]+$/.test(email)) {
      $('.invalid-feedback').html('「E-mail」格式錯誤！');
      return false;
    }
    if (email.length > 80) {
      $('.invalid-feedback').html('「E-mail」限80字元！');
      return false;
    }


    if (!$('#agree').is(':checked')) {
      // 顯示錯誤訊息
      $('.invalid-feedback').html('請先勾選「我已詳閱活動辦法」');
      // 阻止表單提交
      return false;
    }

    // 取得兩個勾選狀態
    var agree = $('#agree').is(':checked') ? 1 : 0 ;
    var order = $('#order').is(':checked') ? 1 : 0 ;

    // 將 email & agree & order & 參加載具 儲存到 sendAllQuestionData 陣列中
    sendAllQuestionData.email = email;
    sendAllQuestionData.agree = agree;
    sendAllQuestionData.order = order;
    sendAllQuestionData.grade = checkGrade(score);
    sendAllQuestionData.source = checkSource();
    sendAllQuestionData.deviceType = deviceType;
    // console.log(sendAllQuestionData);

    grecaptcha.execute('6LcA97YUAAAAAN9SVpbme1g1312tmkQkHHp3rN3Y', {action: 'submit'}).then(function (token) {

      // 建立要送出的資料
      sendAllQuestionData.token = token;
      
			// 送出資料
      $.ajax({
        method: checkStoreUrlMethod,
        url: checkStoreUrl,
        dataType:'json',
        data: JSON.stringify(sendAllQuestionData),
      })
      .done(function (res) {
        if (res.status === true) {
          // console.log(sendAllQuestionData);

          // 將 sendAllQuestionData 儲存到本地儲存區
          sessionStorage.setItem('sendAllQuestionData', JSON.stringify(sendAllQuestionData));
          Swal.close();
      
          // 導轉頁面
          guideResult(score);

        } else {
          if (res.message.includes('email') || res.message.includes('系統繁忙')) {
            Swal.fire({
              icon: 'error',
              text: res.message,
              width: 300,
              allowOutsideClick: false,
              confirmButtonText: '關閉',
            }).then(() => {
              Swal.fire({
                html: emailFormHtml,
                allowOutsideClick: false,
                showCancelButton: false,
                showConfirmButton: false,
                focusConfirm: false
              });
              var mail = sendAllQuestionData.email
              $('.swal2-container #email').val(mail);
            });
          } else {
            Swal.fire({
              icon: 'error',
              text: res.message,
              width: 300,
              allowOutsideClick: false, // 阻止黑頻關閉燈箱
              confirmButtonText: '關閉',
            }).then(() => {
              location.href = location.href
            });
          }
        }
      })
      .fail(function (error) {
        // console.log("系統忙碌中！");
        Swal.fire({
          icon: 'error',
          text: '系統忙碌中，請重新操作！',
          width: 300,
          allowOutsideClick: false, // 阻止黑頻關閉燈箱
          confirmButtonText: '關閉',
        }).then(() => {
          location.href = location.href
        });
      });
    });


  });

  function checkGrade(score) {
    if (score >= 0 && score <= 30) {
      grade = '永續小白';
    } else if (score > 30 && score <= 60) {
      grade = '永續實習生';
    } else if (score > 60 && score <= 80) {
      grade = '永續小隊長';
    } else if (score > 80 && score <= 100) {
      grade = '永續小天才';
    }
    return grade;
  }

  // 產生分數 HTML
  function renderScore(score) {
    // 取得分數容器
    const scoreContainer = $('.score-container');
    // 產生分數 HTML
    const scoreHtml = `
      <span class="score-title">分數：</span>
      <span class="score">${score}</span>
    `;
    // 將分數 HTML 加入分數容器
    scoreContainer.html(scoreHtml);
  }


  // 導向各結果頁面（傳 score & sendAllQuestionData）
  function guideResult(score) {

    let level;

    // 將分數顯示於頁面上 & 導向結果頁面
    if (score >= 0 && score <= 30) {
      level = '永續小白';
      window.location.href = "result1.html";
    } else if (score > 30 && score <= 60) {
      level = '永續實習生';
      window.location.href = "result2.html";
    } else if (score > 60 && score <= 80) {
      level = '永續小隊長';
      window.location.href = "result3.html";
    } else if (score > 80 && score <= 100) {
      level = '永續小天才';
      window.location.href = "result4.html";
    }

    // 將 等級 & 來源 儲存到 sendAllQuestionData 陣列中
    sendAllQuestionData.source = checkSource();


    // 將分數儲存到本地儲存區
    sessionStorage.setItem('sendAllQuestionData', JSON.stringify(sendAllQuestionData));
    sessionStorage.setItem('score', JSON.stringify(score));

  }


  // 重置所有題目
  function restartQuestions() {
    score = 0;
    currentQuestion = 0;
    numQuestion = 1;
    const questions = JSON.parse(JSON.stringify(questionList));
    allQuestionData = []; // 初始化 allQuestionData 陣列
    renderQuestions(questions);
    renderScore(score); // 測試時，看分數使用
    $('.form-progress-indicator[data-current="' + currentQuestion + '"]').addClass('active');
    $('.num').html('Q1');
  }


  // 顯示下一題
  function showNextQuestion() {
    $('body').removeClass('ans');
    // 如果所有題目都被回答過了，則計算分數，導轉頁面
    if (currentQuestion === questionList.length - 1) {
      // 隱藏所有題目容器，顯示總分容器
      $('.question-container').hide();
      $('.total-score-container').show();
      renderScore(score); // 測試時，看分數使用
    } else {
      // 如果還有題目未回答，則顯示下一題題目
      currentQuestion++;
      numQuestion++;
      $('.form-progress-indicator[data-current="'+ currentQuestion +'"]').addClass('active');
      $('.num').html('Q'+ numQuestion);
      $('.block').eq(currentQuestion - 1).hide();
      $('.block').eq(currentQuestion).show();
      renderScore(score); // 測試時，看分數使用
    }
  }


  // Fisher-Yates Shuffle 洗牌演演算法
  function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  // 初始化遊戲
  let deviceType = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ? 'mobile' : 'pc';
  let currentQuestion = 0;
  let numQuestion = 1;
  let score = 0;
  let grade = ''  ; // 等級
  let allQuestionData = []; // 用於儲存答題後的所有結果（前端測試用）
  let allQuestion = []; // 用於儲存題目
  let allSelectAns = []; // 用於儲存答題後的所有答案
  let allIsCorrect = []; // 用於儲存答案的對或錯 （true=1 & false=0）
  let sendAllQuestionData = {}; // 用於儲存答題後的所有結果 & mail & 分數 
  let playState = 'paly';
  restartQuestions();

});